import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'reason-form-free-text',
  template: `
    <div class="answer-wrapper" [ngSwitch]="question.kind">
      <textarea *ngSwitchCase="'free_text'" [(ngModel)]="answer.text" (ngModelChange)="validationChange.emit(!!answer.text.length)"></textarea>
      <input *ngSwitchCase="'referring_doctor'" type="text" [(ngModel)]="answer.text" (ngModelChange)="validationChange.emit(!!answer.text.length)">
    </div>
  `,
})

export class ReasonFormFreeTextComponent {
  @Input() question: any;
  @Input() answer: any;
  @Output() validationChange = new EventEmitter();
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/main/reasons/reason-form/reason-form-free-text.component.ts